var _rtl = false;
$(document).ready(function () {
    if ($("body").css('direction') == 'rtl')
        _rtl = true;
    var lang = document.documentElement.lang;

    var choise = '';

    if (lang === 'en') {
        choise = 'country';

        trans = {

            contactPopupTitles: [
                'Enter Your Number, We\'ll Call You Instantly!',
                'Ready for a 5-Second Callback? Drop Your Number!',
                'Get a Call in 5 Seconds - Leave Your Number Now!',
                'Need Quick Answers? We Call Back in 5 Seconds!',
                'Instant Callback! Enter Your Number Here.',
                'Submit Your Number for Immediate Assistance!',
                'Quick Call! Type Your Number for Rapid Response.',
                'Almost Instant! Enter Your Number for a 5-Second Call.',
                'Let Us Call You Right Now - Just Enter Your Number!',
                'Drop Your Number, Get a Call in Seconds!'
            ]
        }
    } else if (lang === 'ar') {
        choise = 'اختر البلد';

        trans = {

            contactPopupTitles: [
                'أدخل رقمك، سنتصل بك فوراً!',
                'هل أنت مستعد لاستقبال مكالمة في خمس ثوان؟ أدخل رقمك!',
                'احصل على مكالمة في خمس ثوانٍ - اترك رقمك الآن!',
                'هل تحتاج إلى إجابات سريعة؟ سنعاود الاتصال في خمس ثوانٍ!',
                'استدعاء فوري! أدخل رقمك هنا.',
                'قدم رقمك للحصول على مساعدة فورية!',
                'اتصال سريع! اكتب رقمك للاستجابة السريعة.',
                'شبه فوري! أدخل رقمك للحصول على مكالمة في خمس ثوانٍ.',
                'دعنا نتصل بك الآن - فقط أدخل رقمك!',
                'اترك رقمك، واحصل على مكالمة في ثوانٍ!'
            ]

        }
    } else if (lang === 'fr') {
        choise = 'pays';

        trans = {

            contactPopupTitles: [
                'Entrez votre numéro, nous vous appellerons immédiatement!',
                'Prêt pour un rappel de 5 secondes? Laissez votre numéro!',
                'Recevez un appel en 5 secondes - Laissez votre numéro maintenant!',
                'Besoin de réponses rapides? Nous rappelons en 5 secondes!',
                'Rappel instantané! Entrez votre numéro ici.',
                'Soumettez votre numéro pour une assistance immédiate!',
                'Appel rapide! Tapez votre numéro pour une réponse rapide.',
                'Laissez votre numéro, recevez un appel en quelques secondes!'
            ]

        }
    }
    $(window).scroll(function () {
        let scrollHeight = 0;
        if (window.innerWidth < 991) {
            scrollHeight = 50;
        }
        var scroll = $(this).scrollTop();
        if (scroll > scrollHeight) {
            $(".site-header").addClass("has-sticky");
            $(".fixed-side-wrapper").addClass("has-sticky");
            $("#myBar").parent().show(200)

        } else {
            $(".site-header").removeClass("has-sticky");
            $(".fixed-side-wrapper").removeClass("has-sticky");
            $("#myBar").parent().hide()
        }
    });
    $('.onlyNumber').keypress(function () {
        return event.charCode >= 48 && event.charCode <= 57
    })
    $(".search-toggler ,body > .overlay").on('click', function (e) {
        e.preventDefault();
        $("body > .overlay").fadeToggle('fast');
        $('.search-section-wrapper').toggleClass('show');
        $('body').toggleClass('modal-open')
        $('.search-toggler').toggleClass('show');
        $('.mobile-pages-list').removeClass('show');
        $('#search-input').focus();
    });
    $('#search-input').on('keyup', function (event) {

        if (event.keyCode >= 37 && event.keyCode <= 40) return;
        if (event.keyCode == 9 || event.keyCode == 13 || event.keyCode == 16 || event.keyCode == 17 || event.keyCode == 18 || event.keyCode == 19 || event.keyCode == 20 || event.keyCode == 27 || event.keyCode == 33 || event.keyCode == 32 || event.keyCode == 34 || event.keyCode == 35 || event.keyCode == 36 || event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40 || event.keyCode == 44 || event.keyCode == 45 || event.keyCode == 46 || event.keyCode == 91 || event.keyCode == 92) return;

        var query = $(this).val();
        var url = $(this).data('url');
        var loader = '<i class="fa spinner-border"></i>';
        var searchIcon = $('.search-icon');
        if (query != '' && query.length > 2 && query.length < 35) {
            $.ajax({
                url,
                method: "GET",
                data: { s: query },
                beforeSend: function () {
                    searchIcon.attr('src', searchIcon.data('loading'))
                },
                success: function (data) {
                    $('.search-result').fadeIn();
                    searchIcon.attr('src', searchIcon.data('src'))
                    if (data.length != 0) {
                        $('.search-result').html(
                            data.searchResults.map((item) => {
                                return `<a class="result-item" href="${item.link}">${item.title}</a>`
                            }),
                        );
                    } else {
                        $('.search-result').html(
                            `<span class="result-item" href="#"> ${$('#search-input').data('not-found')} </span>`,
                        );
                    }
                },
                error: function (data) {
                    $('.search-result').fadeIn();
                    $('.search-result .none-data').css({ display: 'block' });
                    console.log(data);
                }
            });
        } else {
            $('.search-result').fadeOut();
        }
    });
    $('.auto-complete-item').each(function () {
        $(this).on('click', function () {
            var autoCompleteText = $(this).text();
            $('#search-input').val(autoCompleteText).focus().trigger('keyup');
        })
    })
    $(".owl-featured-offers").owlCarousel({
        rtl: _rtl,
        nav: true,
        navText: [
            '<i class="fas fa-angle-right"></i>',
            '<i class="fas fa-angle-left"></i>',
        ],
        dots: false,
        loop: true,
        lazyLoad: true,
        responsive: {
            0: {
                autoWidth: true,
                margin: 10,
            },
            992: {
                items: 3,
                margin: 10,
            }
        }
    });

    $(".blog-gallery .owl-carousel,.video-gallery .owl-carousel").owlCarousel({
        items: 3,
        autoplay: true,
        loop: true,
        margin: 17,
        nav: true,
        navText: [
            '<i class="fas fa-angle-right"></i>',
            '<i class="fas fa-angle-left"></i>',
        ],
        rtl: _rtl,
        dots: false,
        lazyLoad: true,
        stagePadding: 15,
        responsive: {
            0: {
                items: 1,
            },
            576: {
                items: 2,
            },
            1200: {
                items: 3,
            },
        }
    });

    // companies Carousel
    $('.companies-carousel').owlCarousel({
        loop: true,
        margin: 10,
        rtl: _rtl,
        nav: true,
        dots: false,
        navContainer: '.nav-container',
        touchDrag: true,
        autoplay: false,
        autoplaySpeed: 500,
        autoplayHoverPause: true,
        autoplayTimeout: 2000,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="30.64" height="28.719" viewBox="0 0 30.64 28.719"><defs><style>.next-prev{fill:#e4e4e4;}.b{fill:#37404d;}</style></defs><g transform="translate(-1594.289 -3966)"><circle class="next-prev" cx="14.36" cy="14.36" r="14.36" transform="translate(1596.209 3966)"/><path class="b" d="M9.945,17.77,8.172,19.46a.591.591,0,0,1-1-.435V1.2A1.2,1.2,0,0,0,5.975,0h.011A1.2,1.2,0,0,0,4.779,1.2v17.81a.606.606,0,0,1-1.024.431L2.011,17.759a1.188,1.188,0,0,0-1.687.047l0,0A1.185,1.185,0,0,0,.371,19.48l3.995,3.8a2.393,2.393,0,0,0,3.295-.01l3.923-3.769a1.184,1.184,0,0,0,.05-1.664l-.011-.012A1.185,1.185,0,0,0,9.945,17.77Z" transform="translate(1594.289 3986.594) rotate(-90)"/></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="30.64" height="28.719" viewBox="0 0 30.64 28.719"><defs><style>.a{fill:#e4e4e4;}.b{fill:#37404d;}</style></defs><g transform="translate(-1594.289 -3966)"><circle class="next-prev" cx="14.36" cy="14.36" r="14.36" transform="translate(1596.209 3966)"/><path class="b" d="M9.945,17.77,8.172,19.46a.591.591,0,0,1-1-.435V1.2A1.2,1.2,0,0,0,5.975,0h.011A1.2,1.2,0,0,0,4.779,1.2v17.81a.606.606,0,0,1-1.024.431L2.011,17.759a1.188,1.188,0,0,0-1.687.047l0,0A1.185,1.185,0,0,0,.371,19.48l3.995,3.8a2.393,2.393,0,0,0,3.295-.01l3.923-3.769a1.184,1.184,0,0,0,.05-1.664l-.011-.012A1.185,1.185,0,0,0,9.945,17.77Z" transform="translate(1594.289 3986.594) rotate(-90)"/></g></svg>'],
        navClass: ['owl-prev', 'owl-next'],
        mouseDrag: true,
        responsive: {
            0: {
                items: 2,
            },
            350: {
                items: 3,
                margin: 5,
            },
            768: {
                items: 4,
            },
            992: {
                items: 6,
            },
            1200: {
                items: 7,
            },
        }
    });

    $("#featuredPostsCarousel").owlCarousel({
        items: 2,
        margin: 10,
        smartSpeed: 700,
        nav: true,
        center: true,
        navText: [
            '<i class="fas fa-angle-right"></i>',
            '<i class="fas fa-angle-left"></i>',
        ],
        rtl: _rtl,
        loop: true,
        lazyLoad: true,
        responsive: {
            0: {
                items: 1,
                dots: false,
                center: false,
                margin: 0,
            },
            768: {
                items: 2,
            },
        }
    });

    $("#categoriesCarousel").owlCarousel({
        items: 4,
        margin: 10,
        smartSpeed: 700,
        nav: true,
        dots: false,
        navText: [
            '<i class="fas fa-angle-right"></i>',
            '<i class="fas fa-angle-left"></i>',
        ],
        rtl: _rtl,
        responsive: {
            0: {
                items: 1,
                margin: 0,
            },
            768: {
                items: 2,
            },
            992: {
                items: 4,
            },
        }
    });

    if ($("#callUsCarousel").length) {
        $("#callUsCarousel").owlCarousel({
            items: 1,
            nav: true,
            navText: [
                '<i class="fas fa-angle-right"></i>',
                '<i class="fas fa-angle-left"></i>',
            ],
            dots: true,
            rtl: _rtl,
            loop: true,
        });

    }

    $(".items-carousel").owlCarousel({
        rtl: _rtl,
        nav: true,
        navText: [
            '<i class="fas fa-angle-right"></i>',
            '<i class="fas fa-angle-left"></i>',
        ],
        dots: false,
        loop: true,
        autoWidth: true,
        lazyLoad: true,
        responsive: {
            0: {
                margin: 10,
            },
            992: {
                margin: 20,
            }
        }
    });

    const dynamicText = document.querySelector(".side-contact-form .form-title");
    const words = trans.contactPopupTitles;
    if (dynamicText) {
        // Variables to track the position and deletion status of the word
        let wordIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        const typeEffect = () => {
            const currentWord = words[wordIndex];
            const currentChar = currentWord.substring(0, charIndex);

            dynamicText.textContent = currentChar;

            if (!isDeleting && charIndex < currentWord.length) {
                // If condition is true, type the next character
                charIndex++;
                setTimeout(typeEffect, 100);
            } else if (isDeleting && charIndex > 0) {
                // If condition is true, remove the previous character
                charIndex--;
                setTimeout(typeEffect, 20);
            } else {
                // If word is deleted then switch to the next word
                isDeleting = !isDeleting;
                wordIndex = !isDeleting ? (wordIndex + 1) % words.length : wordIndex;
                setTimeout(typeEffect, 1000);
            }
        }
        typeEffect();
    }

    //Buttons do not have an accessible name -- this to improve speed of website
    $(".owl-carousel .owl-dots .owl-dot").attr('aria-label', 'owl-dot');
    $(".owl-carousel .owl-nav .owl-prev").attr('aria-label', 'owl-prev');
    $(".owl-carousel .owl-nav .owl-next").attr('aria-label', 'owl-next');
    $('.nav-container .owl-prev').attr('aria-label', 'owl-prev')
    $('.nav-container .owl-next').attr('aria-label', 'owl-prev')

    //mobile menu toggler
    if ($(".site-header .toggler").length) {
        $(".site-header .toggler").on('click', function () {
            $("body > .overlay").fadeToggle('fast');
            $("#mainNavMobile").toggleClass("menu-opened");
        });
    }

    $(".overlay").on('click', function () {
        $("body > .overlay").fadeOut('fast');
        $("#mainNavMobile").removeClass("menu-opened");
        $(".navbar .navbar-text.not-sticky .search-form").fadeOut('fast');
        $('.search-toggler').removeClass('show')
    });

    $('#header .site-header .navbar .header-search form input').focus(function () {
        $("body > .overlay").fadeIn('fast');
    })

    $("#mainNavMobile .nav .nav-item .dropdown-menu").prepend('<span class="back dropdown-item fas fa-angle-left"></span>').on('click', 'span', function () {
        $(this).parents('.dropdown-menu').removeClass('show').parents(".dropdown").removeClass('show');
    });
    // ------------------------------------------------------- //
    //   fixed button
    // ------------------------------------------------------- //

    //   tooltip
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    $('.btn-send-subscription').on('click', function (e) {
        e.preventDefault();
        var $this = $(this).parents('form');
        var email = $this.find('input[name=email]').val();
        var policyCheckbox = $this.find('input[name=policy]:checked').length;
        var emailReg = /^([\w\-\.]{2,}\@[a-zA-Z-0-9]{2,}\.[\w\-]{2,4})/;

        var valid = true;
        var validMsg = '';
        if (email == '') {
            valid = false;
            validMsg = $pleaseEnterNameEmail;
        }
        if (policyCheckbox === 0) {
            valid = false;
            validMsg = $policyValidation;
        }


        if (!valid && validMsg != '')
            toastr.warning(validMsg);

        if (valid) {
            $('.btn-send-subscription').prop('disabled', true);

            $.ajax({
                url: '/csrf',
                method: 'get',
                dataType: 'text',
                async: false,
                success: function (response) {
                    // set new token
                    if (JSON.parse(response)) {
                        $('meta[name="csrf-token"]').attr('content', JSON.parse(response).token);
                    }
                }
            }).done(function () {
                $.ajax({
                    url: $this.attr('action'),
                    method: "POST",
                    dataType: "json",
                    data: {
                        email: email,
                        locale: lang,
                        _token: $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        dataLayer.push({ 'event': 'form_submitted' });
                        toastr.success(data.success);
                        $this[0].reset();
                        $('.btn-send-subscription').prop('disabled', false);
                        $this.find('.submit-form').prop('disabled', false);
                    },
                    error: function (data, error_status, error_message) {
                        $('.btn-send-subscription').prop('disabled', false);
                        console.log(data + ' ' + error_status + ' ' + error_message)
                        if (data.status === 429) {
                            toastr.error($TooManyAttempts);
                        } else if (error_message === 'Forbidden') {
                            toastr.error($forbidden);
                        } else {
                            toastr.error($errorSending);
                        }

                    }, complete: function () {
                        $this.find('.submit-form').prop('disabled', false);
                        $('.btn-send-subscription').prop('disabled', false);
                    }
                });
            });

            console.log('subscribe form');
            
            mt('send', 'pageview',
                { email: email, preferred_locale: lang,
                    company: "Safaraq"
                 });
        }

    });
    

    if ($(".page-header.parallaxed").length) {
        $(window).scroll(function () {
            var el = $(this);
            $(".page-header").css({
                top: el.scrollTop() * .6 + 'px',
            });
        });
    }


    $(".tooltip-link").tooltip({
        placement: 'top',
    });

    $(".share-toggler").click(function (e) {
        e.preventDefault();
        $(this).parents('.meta').find('.share-dialog').fadeIn('fast');
    });
    $(".share-dialog .close").click(function (e) {
        e.preventDefault();
        $(this).parent().fadeOut('fast');
    });

    if ($(".sidebar-widget .categories").length) {
        var el = $(".sidebar-widget .categories");
        el.children('li:gt(3)').addClass('d-none');

        $("#showMoreCategories").on('click', function () {
            if (el.children('li:gt(3)').hasClass('d-none')) {
                el.children('li:gt(3)').removeClass('d-none');
                $(this).addClass('d-none');
            } else {
                el.children('li:gt(3)').addClass('d-none');
            }
        });
    }
    //=======================================================================


    // share dialog
    var shareUrl = window.location.href;
    var shareButtons = document.querySelectorAll(".share-btn");
    var shareData = {
        title: "Safaraq Turizim",
        text: $("meta[name=description]").attr('content'),
        url: window.location.href,
    };

    if (shareButtons) {
        [].forEach.call(shareButtons, function (button) {
            button.addEventListener("click", function (event) {
                var width = 650,
                    height = 450;

                event.preventDefault();
                navigator.share(shareData)
            });
        });
    }

    //=======================================================================


    var $choiceCountyCode = 'الرجاء اختيار رمز البلد ',
        $errorEmailMsg = 'عنوان البريد الذي أدخلته غير صحيح! هل تريد المتابعة رغم ذلك؟',
        $pleaseEnterNameMsg = 'الرجاء ادخال الاسم',
        $pleaseEnterNameEmail = 'الرجاء ادخال البريد الالكتروني',
        $pleaseEnterMobileMsg = 'الرجاء ادخال رقم الهاتف',
        $pleaseEnterNumberOnly = 'رقم الهاتف يجب ان يكون ارقام فقط',
        $pleaseEnterValidMobileMsg = 'رقم الهاتف يجب أن يكون أكبر من 5 أرقام',
        $TooManyAttempts = 'عدد كبير جداً من الطلبات، يرجى المحاولة مرة أخرى بعد 30 ثانية',
        $errorSending = 'حدث خطأ ما , يرجى المحاولة لاحقا',
        $policyValidation = 'الرجاء الموافقة على الشروط والأحكام',
        $forbidden = 'هذا الايميل مسجل مسبقا';
    $occupiedPalestine = 'فلسطين المحتلة'

    var $Language = $("html").attr("lang");

    if ($Language === 'en') {
        $choiceCountyCode = 'Please Enter Country Code';
        $errorEmailMsg = 'Invalid Email';
        $pleaseEnterNameMsg = 'Please Enter Name';
        $pleaseEnterMobileMsg = 'Please Enter Mobile Number';
        $pleaseEnterNumberOnly = 'Phone number must be numbers only';
        $pleaseEnterValidMobileMsg = 'Phone number must include more than 5 numbers';
        $TooManyAttempts = 'Too many attempts, please slow down the request.';
        $errorSending = 'There was an error while sending the message, Please try again later.';
        $forbidden = 'The email field has already been taken';
        $policyValidation = 'Please accept Terms and Policies';
        $pleaseEnterNameEmail = 'Please Enter Email';
        $occupiedPalestine = 'occupied palestine'
    } else if ($Language === 'fr') {

        $choiceCountyCode = 'Veuillez choisir le code du pays';
        $errorEmailMsg = 'Mauvaise adresse email Ã  l\'inscription';
        $pleaseEnterNameMsg = 'S\'il vous plaÃ®t entrez votre nom';
        $pleaseEnterMobileMsg = 'S\'il vous plaÃ®t entrez votre numÃ©ro de tÃ©lÃ©phone';
        $pleaseEnterNumberOnly = 'Phone number must be numbers only';
        $pleaseEnterValidMobileMsg = 'Le numÃ©ro de tÃ©lÃ©phone doit comporter plus de 5 chiffres.';
        $TooManyAttempts = 'Trop de demandes. Veuillez rÃ©essayer aprÃ¨s 60 secondes.';
        $errorSending = 'Une erreur s\'est produite lors de l\'envoi du message. Veuillez réessayer ultérieurement.';
        $forbidden = 'The email field has already been taken';
        $pleaseEnterNameEmail = 'Veuillez saisir le courrier électronique';
        $policyValidation = 'Veuillez accepter les conditions et politiques';
        $occupiedPalestine = 'Palestine occupée'
    }

    $.ajax({
        url: `/api/v1/country-code`,
        method: "GET",
        dataType: "json",
        success: function (data) {
            $(".phoneInput").intlTelInput({
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.2/js/utils.js",
                nationalMode: true,
                separateDialCode: true,
                initialCountry: data,
                preferredCountries: ['SA', 'QA', 'TR', 'IQ', 'KW', 'BH', 'AE', 'YE', 'JO', 'DZ', 'TN', 'LY', 'EG', 'SD', 'OM', 'SY']
            });
        }
    })
    $(document).on('click', ".selected-flag", function () {
        $('.country[data-country-code=il] .country-name').text($occupiedPalestine + ' (פלסטין הכבושה)')
        $('.il').addClass('ps');
    });

    $('textarea[name=message]').val('');
    $('.btn-send').on('click', function (e) {
        e.preventDefault();

        var $this = $(this).parents('form');
        var source_form = $this.find('input[name=source_form]').val();
        var imtSrc = $this.find('input[name=imtSrc]').val();
        var coupon = $this.find('input[name=coupon]').val();
        var name = $this.find('input[name=name]').val();
        var email = $this.find('input[name=email]').val();
        var mobile_number = $this.find('input[name=phone]').val();
        var mobile_number_with_code = $this.find('input[name=phone]').intlTelInput("getNumber");
        var countryData = $this.find('input[name=phone]').intlTelInput("getSelectedCountryData");
        var countryCode = countryData.dialCode;
        var message = $this.find('textarea[name=message]').val();
        var fullsrc = $(location).attr('href');
        var domain = $(location).attr('hostname');
        var service_name = $this.find('#service_id').val();
        var country_name = $this.find('.country_id').find('option:selected').val();
        var city_name = $this.find('.city_id').find('option:selected').val();
        var days_count = $this.find('.days_id').find('option:selected').val();
        var hotel_stars_count = $this.find('.hotels_id').find('option:selected').val();
        var source_form_name = $this.find('input[name=source_form_name]').val();
        // program and tours
        var flightBooking = $this.find('input[name=flightBooking]').val();
        var adults = $this.find('input[name=adults]').val();
        var children = $this.find('input[name=children]').val();
        var carWithDriver = $this.find('input[name=carWithDriver]').is(':checked');
        var childrenCount = $this.find('input[name=childrenCount]').val();
        var infants = $this.find('input[name=infants]').val();
        var leavingDate = $this.find('input[name=leavingDate]').val();
        var program = $this.find('input[name="program"]:checked').val();

        if (program && !service_name) {
            service_name = program
        }

        if (carWithDriver) {
            carWithDriver = 'Yes'
        } else {
            carWithDriver = 'No'
        }

        var emailReg = /^([\w\-\.]{2,}\@[a-zA-Z-0-9]{2,}\.[\w\-]{2,4})/;
        var numReg = /[0-9]/;

        var valid = true;
        var validMsg = '';
        if (name == '') {
            valid = false;
            validMsg = $pleaseEnterNameMsg;
        } else if (mobile_number == '') {
            valid = false;
            validMsg = $pleaseEnterMobileMsg;
        } else if (!numReg.test(mobile_number)) {
            valid = false;
            validMsg = $pleaseEnterNumberOnly;
        } else if (mobile_number.length < 5) {
            valid = false;
            validMsg = $pleaseEnterValidMobileMsg;
        } else if (countryCode == 'اختر البلد') {
            valid = false;
            validMsg = $choiceCountyCode;
        } else if (email !== undefined && email !== '' && !emailReg.test(email)) {
            valid = false;
            validMsg = $errorEmailMsg;
        }
        if (validMsg != '')
            toastr.warning(validMsg);

        if (valid) {
            $('.btn-send').prop('disabled', true);
            $.ajax({
                url: '/csrf',
                method: 'get',
                dataType: 'text',
                async: false,
                success: function (response) {
                    if (JSON.parse(response)) {
                        $('meta[name="csrf-token"]').attr('content', JSON.parse(response).token);
                    }
                }
            }).done(function () {
                $.ajax({
                    url: $this.attr('action'),
                    method: "POST",
                    dataType: "json",
                    data: {
                        source_form: source_form,
                        name: name,
                        phone: mobile_number_with_code,
                        email: email,
                        communication_time: '',
                        message: message,
                        fullsrc: fullsrc,
                        imtSrc: imtSrc,
                        coupon: coupon,
                        domain: domain,
                        flightBooking: flightBooking,
                        adults: adults,
                        children: children,
                        children: childrenCount,
                        infants: infants,
                        leavingDate: leavingDate,
                        from_country: country_name,
                        from_city: city_name,
                        car_with_driver: carWithDriver,
                        days: days_count,
                        stars: hotel_stars_count,
                        locale: lang,
                        service_name,
                        source_form_name,
                        _token: $('meta[name="csrf-token"]').attr('content')
                    },
                    beforeSend: function () {
                        $this.find('.send').addClass('d-none');
                        $this.find('.sending').removeClass('d-none');
                    },
                    success: function (data) {
                        if (data.error.length > 0) {
                            data.error.forEach(function (err) {
                                toastr.error(err);
                            })
                        } else {
                            dataLayer.push({ 'event': 'form_submitted' });
                            toastr.success(data.success);
                            $this[0].reset();
                        }
                        $this.find('.send').removeClass('d-none');
                        $this.find('.sending').addClass('d-none');
                        $this.find('.submit-form').prop('disabled', false);
                        $('.btn-send').prop('disabled', false);
                        $('.tab-next').trigger('click');
                    },
                    error: function (data, error_status, error_message) {
                        if (data.status === 429) {
                            toastr.error($TooManyAttempts);
                        } else {
                            toastr.error($errorSending);

                            // send mail to development
                            // code here
                            $.ajax({
                                url: '/send-mail-to-dev',
                                method: 'POST',
                                dataType: 'json',
                                data: {
                                    name: name,
                                    mobile_number: mobile_number_with_code,
                                    email: email,
                                    communication_time: '',
                                    message: message,
                                    fullsrc: fullsrc,
                                    domain: domain,
                                    error_status: data.status,
                                    error_message: error_message,
                                    locale: lang,
                                    _token: $('meta[name="csrf-token"]').attr('content')
                                },
                            })
                            alert($errorSending)

                            // ====================================================================
                        }

                    }, complete: function () {
                        $this.find('.send').removeClass('d-none');
                        $this.find('.sending').addClass('d-none');
                        $this.find('.submit-form').prop('disabled', false);
                        $('.btn-send').prop('disabled', false);
                    }
                });
            })

            console.log('submit form matuic');
            
            mt('send', 'pageview',
                {   company: "Safaraq",
                    email: email, preferred_locale: lang,
                    firstname: name, phone: mobile_number_with_code,
                    source_form_name: source_form_name,
                });

        }

    });
    //====================================================
    send_reserve = function (e) {
        var $this = $(e.target).parents('form');
        var source_form = $this.find('input[name=source_form]').val();
        var name = $this.find('input[name=name]').val();
        var mobile_number = $this.find('input[name=phone]').val();
        var mobile_number_with_code = $this.find('input[name=phone]').intlTelInput("getNumber");
        var countryData = $this.find('input[name=phone]').intlTelInput("getSelectedCountryData");
        var countryCode = countryData.dialCode;
        var message = $this.find('textarea[name=message]').val();
        var fullsrc = $(location).attr('href');
        var domain = $(location).attr('hostname');

        // cars
        var from_to = $this.find('input[name=from_to]').val();

        // program and tours
        var flightBooking = $this.find('input[name=flightBooking]').val();
        var adults = $this.find('input[name=adult-number]').val();
        var children = $this.find('input[name=child-number]').val();
        var babies = $this.find('input[name=baby-number]').val();
        var students = $this.find('input[name=student-number]').val();
        var bags = $this.find('input[name=bag-number]').val();
        var flight_option = $this.find('input[name=flight-option]:checked').val();
        var flight_class = $this.find('select[name=flight-class]').val();

        var infants = $this.find('input[name=infants]').val();
        var dateRange = $this.find('input[name=daterange]').val();
        var room = $this.find('select[name=room]').val();
        var hotel = $this.find('input[name=hotel]').val();
        var service_name = $this.find('input[name=service-name]').val();

        // this is for flight multi trip
        var flightValues = []
        $(".flight-reseve-form .repeater-default").each(function (index, item) {
            flightValues[index] = $(item).children().find('.from input').val()
            flightValues[index] = flightValues[index] + ' - ' + $(item).find('.to input').val()
            flightValues[index] = flightValues[index] + ' - ' + $(item).find('.daterange-select input').val()
        })

        var numReg = /[0-9]/;
        var valid = true;
        var validMsg = '';
        if (name == '') {
            valid = false;
            validMsg = $pleaseEnterNameMsg;
        } else if (mobile_number == '') {
            valid = false;
            validMsg = $pleaseEnterMobileMsg;
        } else if (!numReg.test(mobile_number)) {
            valid = false;
            validMsg = $pleaseEnterNumberOnly;
        } else if (mobile_number.length < 5) {
            valid = false;
            validMsg = $pleaseEnterValidMobileMsg;
        } else if (countryCode == 'اختر البلد') {
            valid = false;
            validMsg = $choiceCountyCode;
        }

        if (validMsg != '')
            toastr.warning(validMsg);

        var with_special_needs = null;
        if ($('input#with-special-needs').is(':checked')) {
            with_special_needs = 'true';
        }
        if (valid) {
            $('.btn-send-reserve').prop('disabled', true);
            $.ajax({
                url: '/csrf',
                method: 'get',
                dataType: 'text',
                async: false,
                success: function (response) {
                    if (JSON.parse(response)) {
                        $('meta[name="csrf-token"]').attr('content', JSON.parse(response).token);
                    }
                }
            }).done(function () {
                $.ajax({
                    url: $this.attr('action'),
                    method: "POST",
                    dataType: "json",
                    data: {
                        source_form: source_form,
                        name: name,
                        phone: mobile_number_with_code,
                        communication_time: '',
                        message: message,
                        fullsrc: fullsrc,
                        domain: domain,
                        flightBooking: flightBooking,
                        adults: adults,
                        children: children,
                        babies: babies,
                        students: students,
                        bags: bags,
                        flightValues: flightValues,
                        flight_option: flight_option,
                        flight_class: flight_class,
                        from_to: from_to,
                        with_special_needs: with_special_needs,
                        dateRange: dateRange,
                        room: room,
                        hotel: hotel,
                        service_name: service_name,
                        infants: infants,
                        locale: lang,
                        _token: $('meta[name="csrf-token"]').attr('content')
                    },
                    beforeSend: function () {
                        $this.find('.send').addClass('d-none');
                        $this.find('.sending').removeClass('d-none');
                    },
                    success: function (data) {
                        if (data.error.length > 0) {
                            data.error.forEach(function (err) {
                                toastr.error(err);
                            })
                        } else {
                            dataLayer.push({ 'event': 'form_submitted' });
                            toastr.success(data.success);
                            $this[0].reset();
                            clearValuesAfterSubmit($this)
                        }

                        $this.find('.send').removeClass('d-none');
                        $this.find('.sending').addClass('d-none');
                        $this.find('.submit-form').prop('disabled', false);
                        $('.btn-send-reserve').prop('disabled', false);
                    },
                    error: function (data, error_status, error_message) {
                        if (data.status === 429) {
                            toastr.error($TooManyAttempts);
                        } else {
                            toastr.error($errorSending);

                            // send mail to development
                            // code here
                            $.ajax({
                                url: '/send-mail-to-dev',
                                method: 'POST',
                                dataType: 'json',
                                data: {
                                    name: name,
                                    mobile_number: mobile_number_with_code,
                                    email: email,
                                    communication_time: '',
                                    message: message,
                                    fullsrc: fullsrc,
                                    domain: domain,
                                    error_status: data.status,
                                    error_message: error_message,
                                    locale: lang,
                                    _token: $('meta[name="csrf-token"]').attr('content')
                                },
                            })
                            alert($errorSending)

                            // ====================================================================
                        }

                    }, complete: function () {
                        $this.find('.send').removeClass('d-none');
                        $this.find('.sending').addClass('d-none');
                        $this.find('.submit-form').prop('disabled', false);
                        $('.btn-send-reserve').prop('disabled', false);
                    }
                });
            })
        }
    }

    function clearValuesAfterSubmit(form) {
        if (form) {
            $(form).each(function () {
                $(this).find(':input').val("")
            });
        }
    }

    //To Hide Modal on Click Back Button
    //-----------
    $('#modalContact').on('shown.bs.modal', function () {
        var urlReplace = '#modalContact'
        history.pushState(null, null, urlReplace)
    })

    $(window).on('popstate', function () {
        $('.modal').modal('hide')
    })
    //-----------

    // add smooth scroll to table content
    $('.mce-toc [contenteditable]').attr('contenteditable', 'false')
    $('.mce-toc').removeClass('card')
    $(".mce-toc li > a").on("click", function (e) {
        e.preventDefault();
        var target = $(this).attr("href");
        var headerHeight = $(".site-header").height() + 10;
        var scrollToPosition = $(target).offset().top - headerHeight;
        $('html').animate({ 'scrollTop': scrollToPosition }, 1000, function () {
            window.history.pushState(null, '', target);
        }
        );
    });
    if (window.location.hash) {
        $('html').animate({ 'scrollTop': $(window.location.hash).top - ($(".navbar").height() + 10) }, 300);
    }
    /*  change currency */
    $('.curr-code').on('click', function () {
        const currency = $(this).data('curr');
        console.log(currency)
        $.ajax({
            url: `/currency/${currency}`,
            method: "GET",
            dataType: "json",
            success: function (data) {

                if (data.success) location.reload();
            }
        })
    });
    /* End  change currency */

    /* Start Booking Counter */
    let incPersonBtn = $(".increase-person");
    let decPersonBtn = $('.decrease-person');

    let counter = 1;

    let priceDetails = $('.total-booking-price .price-value');

    if (priceDetails !== null) {
        let personNumber = $(".current-persons-count .count-number");
        let priceBooking = priceDetails.text();

        modifyBookingUrl(personNumber);

        // Persons Icons
        let onePersonIcon = $('img.one-person');
        let twoPersonIcon = $('img.two-persons');
        let multiplePersonsIcon = $('img.multiple-persons');

        function calculatBookingPrice() {
            priceDetails.text(parseFloat(priceBooking * personNumber.text()).toFixed(2));

            if (parseInt(personNumber.text()) > 1 && personNumber.text() <= 2) {
                onePersonIcon.addClass('d-none');
                twoPersonIcon.removeClass('d-none');
                multiplePersonsIcon.addClass('d-none');
            } else if (parseInt(personNumber.text()) > 2) {
                onePersonIcon.addClass('d-none');
                twoPersonIcon.addClass('d-none');
                multiplePersonsIcon.removeClass('d-none');
            } else {
                onePersonIcon.removeClass('d-none');
                twoPersonIcon.addClass('d-none');
                multiplePersonsIcon.addClass('d-none');
            }
        }

        incPersonBtn.on('click', function () {
            if (counter < 5) {
                counter++;
                personNumber.text(counter);
                calculatBookingPrice();
                modifyBookingUrl(personNumber);
            }
        });

        decPersonBtn.on('click', function () {
            if (counter >= 2) {
                counter--;
                personNumber.text(counter);
                calculatBookingPrice();
                modifyBookingUrl(personNumber);
            }
        });
    } else {
        $('.sticky-booking').css('display', 'none');
    }

    function modifyBookingUrl(personNumber) {
        let bookingLang = document.querySelector('html').getAttribute('lang');
        let currentLang;

        if (bookingLang !== 'ar') {
            currentLang = '/' + window.location.pathname.split('/')[1];
        } else {
            currentLang = '';
        }
        let book_now_url = new URL(window.location.origin + currentLang + '/booking');
        let params = new URLSearchParams(book_now_url.search);
        let book_now_btn = $('.sticky-booking .booknow-btn a');
        var trip = new URL(window.location.href).pathname.split('/').filter(Boolean).pop();

        params.set('persons-count', personNumber.text());
        params.set('trip', trip);


        book_now_url.search = params.toString();

        let new_url = book_now_url.toString();

        book_now_btn.attr('href', new_url);
    }

    /* End Booking Counter */

    /* change src to data-light in mobile */

    $('.toggle-mobile-pages-list').on('click', function () {
        $('.mobile-pages-list').toggleClass('show');
        $('body').toggleClass('modal-open');
    });
    $('.contactModalButton').on('click', function () {
        if ($('.sb-chat').hasClass('sb-active')) {
            $('.sb-chat-btn').click();
        }
    });
    $('#contactModal').on('shown.bs.modal', function () {
        if ($(window).width() < 991) {
            const tabs_content = new Swiper('.tabs-content', {
                autoHeight: true,
                spaceBetween: 20,
                navigation: false,
                pagination: false,
                slidesPerView: 1,
                allowTouchMove: false,
                rewind: true,
                navigation: {
                    nextEl: '.tab-next',
                    prevEl: '.tab-back',
                },
            });
        }
    })
    $('.ProgramCardCheckbox').on('click', function () {
        $('#' + $(this).attr('for')).trigger('change')
    })
    $(".program-radio").on('change', function () {
        var id = $(this).attr('id');
        $('.ProgramCardCheckbox').removeClass('active');
        if ($(this).prop('checked', true)) {
            $(`[for=${id}]`).addClass('active');
        }
    })
    // Function to restrict input to numeric characters
    function restrictToNumeric(event) {
        const input = $(this);
        input.val(input.val().replace(/[^0-9|+]/g, '')); // Remove non-numeric characters
    }

    // Attach the restrictToNumeric function to the input elements using jQuery
    $('.only-number').on('input', restrictToNumeric);
});

//Add classes based on the language
switch (document.documentElement.getAttribute("lang")) {
    case "ar":
        document.body.classList.add("arabic");
        document.body.classList.add("rtl");
        break;
    case "fa":
        document.body.classList.add("persian");
        document.body.classList.add("rtl");
        break;
    case "en":
        document.body.classList.add("english");
        document.body.classList.add("ltr");
        break;
    case "ru":
        document.body.classList.add("russian");
        document.body.classList.add("ltr");
        break;
    case "fr":
        document.body.classList.add("french");
        document.body.classList.add("ltr");
        break;
}
